/**
 * STORE HOURS - Single source of truth
 * Update here to change hours across the entire app
 * Format: 24-hour time 'HH:MM'
 * Each day can have multiple time slots (lunch & dinner)
 */
export const STORE_HOURS = {
  0: [{ open: '09:00', close: '15:00' }, { open: '17:00', close: '22:00' }], // Sunday
  1: [{ open: '11:00', close: '14:00' }, { open: '17:00', close: '22:00' }], // Monday
  2: [], // Tuesday — closed
  3: [{ open: '11:00', close: '14:00' }, { open: '17:00', close: '22:00' }], // Wednesday
  4: [{ open: '11:00', close: '14:00' }, { open: '17:00', close: '22:00' }], // Thursday
  5: [{ open: '09:00', close: '14:00' }, { open: '17:00', close: '23:00' }], // Friday
  6: [{ open: '09:00', close: '15:00' }, { open: '17:00', close: '23:00' }], // Saturday
};

// Helper to convert 24h to 12h format
const formatTime12h = (time24) => {
  const [h, m] = time24.split(':').map(Number);
  const suffix = h >= 12 ? 'PM' : 'AM';
  const hour12 = h % 12 || 12;
  return `${hour12}:${m.toString().padStart(2, '0')} ${suffix}`;
};

// Formats a day's slots, e.g. "11:00 AM - 2:00 PM, 5:00 PM - 10:00 PM" (or "Closed")
const formatDayHours = (day) => {
  const slots = STORE_HOURS[day] || [];
  if (slots.length === 0) return 'Closed';
  return slots.map((s) => `${formatTime12h(s.open)} - ${formatTime12h(s.close)}`).join(', ');
};

/**
 * Human-readable opening hours for display
 * Auto-generated from STORE_HOURS above
 */
export const openingHours = [
  { day: 'Monday', hours: formatDayHours(1) },
  { day: 'Tuesday', hours: formatDayHours(2) },
  { day: 'Wednesday', hours: formatDayHours(3) },
  { day: 'Thursday', hours: formatDayHours(4) },
  { day: 'Friday', hours: formatDayHours(5) },
  { day: 'Saturday', hours: formatDayHours(6) },
  { day: 'Sunday', hours: formatDayHours(0) },
];
